import * as React from 'react';
import { useIntl } from 'react-intl';
import { CmdModal } from '@commander-services/gui-components';
import { TEmployeeRecord } from '../interfaces';

interface ChipsCellWithModalProps {
  data: TEmployeeRecord;
  align?: string;
}

function ChipsCellWithModal({ data, align = 'center' }: ChipsCellWithModalProps) {
  const { formatMessage: f } = useIntl();
  const [isOpenModal, setIsOpenModal] = React.useState(false);

  const handleOpenModal = (event) => {
    event.preventDefault();

    setIsOpenModal(true);
  };
  const handleClose = () => {
    setIsOpenModal(false);
  };

  return (
    <>
      {isOpenModal && (
        <CmdModal
          id={`chips-table-employees-roles-${data.id}-modal`}
          title={f({ id: `table_list.columns.gdprUsers.role` })}
          width="400px"
          footerButtons={[
            {
              id: 'tableTdModalBtn',
              type: 'button',
              title: f({ id: 'form.close' }),
              className: 'e-button',
              closeCallback: handleClose,
            },
          ]}
          usePortal
        >
          <div style={{ margin: '-24px -24px -12px -24px' }}>
            {data.roles.map((item: string, key: number) => {
              return (
                <div
                  style={{
                    padding: '10px 32px',
                    color: '#555',
                    background: key % 2 ? '#f0f0f0' : '',
                  }}
                  key={item}
                >
                  {item}
                </div>
              );
            })}
          </div>
        </CmdModal>
      )}
      <div
        className={`text-cell align-${align}`}
        style={{ flex: 1, cursor: 'pointer' }}
        data-cy={`chips-table-employees-${data.id}`}
        onClick={handleOpenModal}
        key={data.id}
      >
        <div className="e-table-label">
          {/* <i className={`cmd-icon ${handleIconClass(data)}`} /> */}
          {`${data.roles[0]} +${data.roles.length - 1}`}
        </div>
      </div>
    </>
  );
}

export default ChipsCellWithModal;
